<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      @openAddDialog="openAddDialog"
      @reload="getData()"
      @batchDel="submitDel"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @openAddDialog="openAddDialog"
        @batchDel="batchDel"
      />
    </Main>
    <DetailDialog
      v-if="goodsDetailDialogParams.visible"
      :changeOrderCode="changeOrderCode"
      :disabled="goodsDetailDialogParams.disabled"
      :visible="goodsDetailDialogParams.visible"
      :title="goodsDetailDialogParams.title"
      :changeOrderGoodsCode="goodsDetailDialogParams.code"
      @reload="getData()"
      @close="() => (goodsDetailDialogParams.visible = false)"
      ref="detailDialog"
    />
    <AddDialog
      v-if="addDialogParams.visible"
      :changeOrderCode="changeOrderCode"
      :disabled="addDialogParams.disabled"
      :visible="addDialogParams.visible"
      :title="addDialogParams.title"
      @reload="getData()"
      @close="() => (addDialogParams.visible = false)"
    />
  </div>
</template>
<script>
import Main from './main'
import Header from './header'
import DetailDialog from '../edit-form/dialog.vue'
import AddDialog from '../edit-form/add-dialog.vue'
export default {
  components: { Main, Header, DetailDialog, AddDialog },
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      goodsDetailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
      addDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.changeOrderCode) return
      this.loading = true
      this.$api
        .changeOrderGoodsPackageSizeListApi({ changeOrderCode: this.changeOrderCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchDel() {
      const orderGoodsCodeList = this.$refs.tableMain.getCheckboxRecords()
      if (orderGoodsCodeList) this.submitDel(orderGoodsCodeList)
    },
    submitDel(orderGoodsCodeList) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .changeOrderGoodsPackageSizeDelApi({ orderGoodsCodeList })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
          })
      })
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        edit:
          this.$l('INDEX.order_goods_package_size_dialog_title_edit') || '编辑产品包装尺寸',
        detail:
          this.$l('INDEX.order_goods_package_size_dialog_title_detail') ||
          '查看产品包装尺寸',
      }
      this.goodsDetailDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    openAddDialog({ type }) {
      const types = {
        add:
          this.$l('INDEX.order_goods_package_size_dialog_title_add') ||
          '批量增加产品包装尺寸',
      }
      this.addDialogParams = {
        visible: true,
        title: types[type],
        disabled: type === 'detail',
      }
    },
  },
}
</script>
